import { render } from "./UITabsGroup.vue?vue&type=template&id=ae8e3fa8&scoped=true"
import script from "./UITabsGroup.vue?vue&type=script&lang=js"
export * from "./UITabsGroup.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-ae8e3fa8"

export default script